import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";

import {
  type GetWorkerIncomeQueryParams,
  type GetWorkerIncomeResponse,
  getWorkerIncomeResponseSchema,
} from "../types";

export function useWorkerIncome(
  params: { workerId: string; year: number },
  options: UseGetQueryOptions<GetWorkerIncomeResponse> = {}
): UseQueryResult<GetWorkerIncomeResponse> {
  const { workerId, year } = params;
  const queryParams: GetWorkerIncomeQueryParams = {
    filter: {
      year: {
        eq: year,
      },
    },
  };
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${workerId}/income`,
    responseSchema: getWorkerIncomeResponseSchema,
    queryParams,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKER_INCOME_FAILURE,
    },
    ...options,
  });
}
